import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedPosts = ({ posts, currentCategory }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <section className="mt-16 pt-12 border-t border-border">
      <div className="flex items-center gap-2 mb-8">
        <Icon name="BookOpen" size={24} color="var(--color-accent)" />
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">
          Related Articles in {currentCategory}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts?.map((post) => (
          <Link
            key={post?.id}
            to={`/blog-article-view/${post?.id}`}
            className="group bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <Image
                src={post?.image}
                alt={post?.imageAlt || post?.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 bg-card/90 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-foreground">
                {post?.category}
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-foreground mb-2 line-clamp-2 group-hover:text-accent transition-colors">
                {post?.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                {post?.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Calendar" size={12} />
                  <span>{formatDate(post?.publishedDate)}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={12} />
                  <span>{post?.readTime} min</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;